import { Component, OnInit } from '@angular/core';
import {UserDto, UserService} from '../../services/user.service';
import {NgxSpinnerService} from 'ngx-spinner';
import * as _ from 'lodash';
import {ShoppingCartService} from '../../services/shopping-cart.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', '../../../assets/css/main.css']
})
export class HomeComponent implements OnInit {

  userDtos: UserDto[];
  constructor(private userService: UserService,
              private cart: ShoppingCartService,
              private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.cart.cleanUpShoppingCart();
    this.spinner.show();
    this.userService.fetchAllUser()
      .then((userDtos: UserDto[]) => {
        this.userDtos = _.filter(userDtos, (user) => user.testUser === false);
        // this.userDtos = userDtos;
        this.spinner.hide();
      });
  }

}
